<ng-container *ngIf="isLadderRate">
  <span
    style="margin-right: var(--ds-cont-spacing-common-gap-sm); cursor: pointer"
    title="Invert to {{tooltip}}"
    class="ui-clickable fa icon-swap_horiz"
  ></span>
  <span>{{value}}</span>
</ng-container>

<ng-container *ngIf="isAggregate">
  <span
    (click)="doClickAggregate($event)"
    style="margin-right: var(--ds-cont-spacing-common-gap-sm); cursor: pointer"
  >
    <ng-container *ngIf="aggregateExpanded; then contractIcon; else expandIcon"></ng-container>
    <ng-template #contractIcon>
      <i
        class="ladder-orders-aggregate-expansion-icon no-cell-mouse-down icon icon_ion_remove_circle_filled"
      ></i>
    </ng-template>
    <ng-template #expandIcon>
      <i
        class="ladder-orders-aggregate-expansion-icon no-cell-mouse-down icon icon_ion_add_circle_filled"
      ></i>
    </ng-template>
  </span>
  <span>({{aggregateVisibleCount| number:"1.0-0"}})</span>
</ng-container>

<ng-container *ngIf="isAggregated && aggregateExpanded">
  <span style="margin-right: var(--ds-cont-spacing-common-gap-sm); cursor: normal"
    ><i class="ladder-orders-aggregate-icon icon icon_ion_collapse_filled"></i
  ></span>
</ng-container>

<ng-container *ngIf="hasValue">
  <span [innerHtml]="sanitizer.bypassSecurityTrustHtml(value)"></span>
</ng-container>
